//export const INTEGRATION_API_URL = 'https://connect-api.akosmd.com/'//'https://staging-connect-api.akosmd.com/';

global.isDevEnv = false;
//'https://fhir-staging.akosmd.com/'
const INTEGRATION_API_URL = global.isDevEnv
  ? 'https://fhir-staging.akosmd.com/' //'https://tough-cycles-enjoy-103-115-182-123.loca.lt/' 
  : 'https://fhir-api.akosmd.com/';
const CHAT_BOT_URL = global.isDevEnv
  ? 'https://bot.akosmd.com/devchatbot/ai/'
  : 'https://bot.akosmd.com/prodchatbot/ai/';
const TALK_TO_PROVIDER_URL = global.isDevEnv
  ? 'https://staging-medical.akosmd.com/#!/room'
  : 'https://medical.akosmd.com/#!/room/';
const CONNECT_API_BASE_URL = global.isDevEnv
  ? 'https://staging-connect-api.akosmd.com/'
  : 'https://connect-api.akosmd.com/';
const NEW_API_BASE_URL = global.isDevEnv
  ? 'https://staging-newapi.akosmd.com/'
  : 'https://newapi.akosmd.com/';
const API_KEY_DEV = global.isDevEnv ? '46437422' : '45732912';
const RXNORM_API = global.isDevEnv
  ? 'https://rxnav.nlm.nih.gov/REST'
  : 'https://rxnav.nlm.nih.gov/REST';
const ALLERGY_OPTIONS_URL = global.isDevEnv
  ? 'https://rxnav.nlm.nih.gov/'
  : 'https://rxnav.nlm.nih.gov/';
const SOCKET_URL = global.isDevEnv
  ? 'https://staging-socket.akosmd.com'
  : 'https://socket.akosmd.com';
const CLINICAL_ICD_URL = global.isDevEnv
  ? 'https://clinicaltables.nlm.nih.gov/'
  : 'https://clinicaltables.nlm.nih.gov/';
const PVERIFY_URL = global.isDevEnv
  ? 'https://api.pverify.com/Test/API/'
  : 'https://api.pverify.com/Token/';
const API_URL = global.isDevEnv
  ? 'https://staging-api.akosmd.com'
  : 'https://api.akosmd.com/';
const GOOGLEPAY_MERCHANT_ID = global.isDevEnv
  ? '647030827'//'17369998254377824045'
  : '647030827'//'17369998254377824045';
// const APPLEPAY_MERCHANT_ID = global.isDevEnv
//   ? 'merchant.com.akosmd.apricushealth.sandbox'
//   : 'merchant.com.akosmd.apricushealth.production';

const CLIENT_ID = global.isDevEnv ? '9' : '6';

const CLIENT_SECRET = global.isDevEnv
  ? 'LxFLgsnsGQYMVZKU2MEKTqcXdNKsdfv5zwhVJeB1'
  : 'wIhcpNnRsr1yCXw36gcAIscacV3NBRYodLJbcXPw';

const APPLICATION_ID = 20000;//10000;
// // const APP_LINK =
// //   Platform.OS === 'ios'
// //     ? 'https://apps.apple.com/us/app/akos/id1187895369'
//     : 'market://details?id=com.akosmd.patientapp';

const WEBHOOKS_CHAT = global.isDevEnv
  ? 'https://chat.googleapis.com/v1/spaces/AAAAr0apmzo/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=RxiKa9PmYsLF3vpiCZqwCy6s3lQw4uP29PQ70xHbe-g%3D'//'https://chat.googleapis.com/v1/spaces/AAAAUCTRUeE/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=lkNELcFK97PvhM6Jh-VSLchjQO7QrilswcUrrg6dUIk%3D'
  : 'https://chat.googleapis.com/v1/spaces/AAAAuiA05WY/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=Q2uwbr7WbQV7t6cb30aNypI8MS6ti6ZKcOT8RdTLsFU%3D'//'https://chat.googleapis.com/v1/spaces/AAAAEQLqqfc/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=t_9c4biPGqhQm7-MVPZhy8EisTJublqQ-X5PhmPd-Gw%3D'//'https://chat.googleapis.com/v1/spaces/AAAAUCTRUeE/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=lkNELcFK97PvhM6Jh-VSLchjQO7QrilswcUrrg6dUIk%3D';

const LOGIN_LINK = global.isDevEnv
  ? 'https://staging-360.akosmd.com/login'//'https://staging-apricushealth.akosmd.com/login'
  : 'https://360.akosmd.com/login'//'https://apricushealth.akosmd.com/login';

const BASIC_AUTH = global.isDevEnv ? 'Basic MTIzNDU6MTIzNDU=' : 'Basic MTIzNDU6MTIzNDU=';

const ROOM_VDPC = global.isDevEnv ? 'vdpc' : 'vpc';//vdpc
const ROOM_DEMO = global.isDevEnv ? 'vdpc' : 'enrolled_in_programs';
const ROOM_URGENT_CARE = global.isDevEnv ? 'vdpc' : 'urgentcarenewroom';

export {
  INTEGRATION_API_URL,
  CHAT_BOT_URL,
  TALK_TO_PROVIDER_URL,
  CONNECT_API_BASE_URL,
  NEW_API_BASE_URL,
  API_KEY_DEV,
  RXNORM_API,
  ALLERGY_OPTIONS_URL,
  SOCKET_URL,
  CLINICAL_ICD_URL,
  PVERIFY_URL,
  API_URL,
  GOOGLEPAY_MERCHANT_ID,
  // APPLEPAY_MERCHANT_ID,
  CLIENT_ID,
  CLIENT_SECRET,
  APPLICATION_ID,
  //APP_LINK,
  WEBHOOKS_CHAT,
  LOGIN_LINK,
  ROOM_DEMO,
  ROOM_VDPC,
  BASIC_AUTH,
  ROOM_URGENT_CARE
};
